"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames2 = _interopRequireDefault(require("classnames"));
var _brands = require("../../utils/brands/brands");
var _calculatePriceReduction = _interopRequireDefault(require("../../utils/product/calculatePriceReduction"));
var _createUnitPriceString = _interopRequireDefault(require("./utils/createUnitPriceString"));
var _priceModule = _interopRequireDefault(require("./price.module.scss"));
var _getPriceOrRange = require("./helpers/getPriceOrRange");
var _generateAriaLabel = require("./helpers/generateAriaLabel");
var _WasNowPrice = require("./WasNowPrice");
var _NowWasPrice = require("./NowWasPrice");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Price = function Price(_ref) {
  var brand = _ref.brand,
    className = _ref.className,
    dataTestPrefix = _ref.dataTestPrefix,
    _ref$price = _ref.price,
    was = _ref$price.was,
    then1 = _ref$price.then1,
    then2 = _ref$price.then2,
    now = _ref$price.now,
    pricePrefix = _ref.pricePrefix,
    priceSuffix = _ref.priceSuffix,
    unitPriceInfo = _ref.unitPriceInfo,
    usageContext = _ref.usageContext,
    _ref$showPriceReducti = _ref.showPriceReduction,
    showPriceReduction = _ref$showPriceReducti === void 0 ? false : _ref$showPriceReducti,
    _ref$isNowWas = _ref.isNowWas,
    isNowWas = _ref$isNowWas === void 0 ? false : _ref$isNowWas;
  var unitPriceWording = (0, _createUnitPriceString["default"])(unitPriceInfo);
  var isAnyday = (0, _brands.isAnydayBrand)(brand);
  var isProductCard = Boolean(usageContext === 'product-card');
  var isQuickView = Boolean(usageContext === 'quick-view');
  if (!now) {
    return null;
  }
  var reducedPrice = showPriceReduction ? (0, _calculatePriceReduction["default"])({
    was: was,
    now: now
  }) : null;
  var priceSuffixText = !isProductCard ? priceSuffix : null;
  if (was) {
    if (isNowWas) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_NowWasPrice.NowWasPrice, {
        className: className,
        dataTestPrefix: dataTestPrefix,
        price: {
          was: was,
          then1: then1,
          then2: then2,
          now: now
        },
        pricePrefix: pricePrefix,
        priceSuffix: priceSuffixText,
        usageContext: usageContext,
        showPriceReduction: showPriceReduction,
        unitPriceWording: unitPriceWording,
        isAnyday: isAnyday,
        isProductCard: isProductCard,
        isQuickView: isQuickView,
        reducedPrice: reducedPrice
      });
    } else {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_WasNowPrice.WasNowPrice, {
        className: className,
        dataTestPrefix: dataTestPrefix,
        price: {
          was: was,
          then1: then1,
          then2: then2,
          now: now
        },
        pricePrefix: pricePrefix,
        priceSuffix: priceSuffixText,
        usageContext: usageContext,
        showPriceReduction: showPriceReduction,
        unitPriceWording: unitPriceWording,
        isAnyday: isAnyday,
        isProductCard: isProductCard,
        isQuickView: isQuickView,
        reducedPrice: reducedPrice
      });
    }
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
    className: (0, _classnames2["default"])(className, _priceModule["default"]['price'], _priceModule["default"]["price--context-".concat(usageContext)], _defineProperty({}, _priceModule["default"]["price--anyday"], isAnyday)),
    "data-test": dataTestPrefix ? "".concat(dataTestPrefix, "-price") : 'price',
    "aria-label": (0, _generateAriaLabel.generateAriaLabel)(undefined, undefined, undefined, now, pricePrefix, priceSuffixText),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
      className: (0, _classnames2["default"])(_priceModule["default"]['price__now']),
      "data-test": dataTestPrefix ? "".concat(dataTestPrefix, "-price-now") : 'price-now',
      role: "presentation",
      children: [pricePrefix && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: (0, _classnames2["default"])(_priceModule["default"]['price__prefix']),
          children: pricePrefix
        }), ' ']
      }), (0, _getPriceOrRange.getPriceOrRange)(now), priceSuffixText && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [' ', /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: (0, _classnames2["default"])(_priceModule["default"]['price__suffix']),
          children: priceSuffixText
        })]
      })]
    }), unitPriceWording && !isProductCard ? /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: (0, _classnames2["default"])(_priceModule["default"]['price__unit-price'], _priceModule["default"]["price__unit-price-".concat(usageContext)]),
      "aria-label": unitPriceWording,
      children: unitPriceWording
    }) : null]
  });
};
Price.defaultProps = {
  brand: null,
  className: null,
  dataTestPrefix: null,
  price: {},
  pricePrefix: null,
  priceSuffix: null,
  unitPriceInfo: null,
  usageContext: 'product-card',
  showPriceReduction: false
};
Price.propTypes = {
  brand: _propTypes["default"].string,
  className: _propTypes["default"].string,
  dataTestPrefix: _propTypes["default"].string,
  price: _propTypes["default"].shape({
    was: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].shape({
      from: _propTypes["default"].string,
      to: _propTypes["default"].string
    })]),
    then1: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].shape({
      from: _propTypes["default"].string,
      to: _propTypes["default"].string
    })]),
    then2: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].shape({
      from: _propTypes["default"].string,
      to: _propTypes["default"].string
    })]),
    now: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].shape({
      from: _propTypes["default"].string,
      to: _propTypes["default"].string
    })])
  }),
  pricePrefix: _propTypes["default"].string,
  /** Suffix text for the price - not displayed when usageContext is 'product-card' */
  priceSuffix: _propTypes["default"].string,
  unitPriceInfo: _propTypes["default"].shape({
    pricePerUnit: _propTypes["default"].shape({
      currency: _propTypes["default"].string,
      price: _propTypes["default"].number
    }),
    unit: _propTypes["default"].shape({
      measure: _propTypes["default"].string,
      quantity: _propTypes["default"].number
    })
  }),
  usageContext: _propTypes["default"].oneOf(['product-card', 'quick-view', 'pdp']),
  showPriceReduction: _propTypes["default"].bool
};
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(Price);